import { useMediaQuery } from "./useMediaQuery";
/**
 * Returns `true` on a device whose primary pointer cannot hover — a phone, a
 * tablet, a touch-first laptop.
 *
 * Radix's hover card opens on `pointerenter` only for a pointer that is not
 * touch, so on a touch-primary device the card can never open at all: surfaces
 * read this to render the plain element instead of a trigger, a Popper root and
 * their portal machinery per chip, none of which could ever do anything.
 *
 * BEST-EFFORT, not a guarantee. A touchscreen laptop reports `pointer: fine` /
 * `hover: hover`, so the trigger mounts there and the element must stay usable
 * by tap regardless — which it is: Radix's `preventDefault()` on `touchstart`
 * is ignored, because React registers `touchstart` passively at the root.
 *
 * Subscribed rather than read once, because the answer changes while mounted:
 * a convertible folds into tablet mode, a mouse is plugged into a tablet.
 */ export function useCoarsePointer() {
    return useMediaQuery("(hover: none), (pointer: coarse)");
}

//# sourceMappingURL=useCoarsePointer.js.map